import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";

import EditorField from "../../templates/modules/forms/Editor";

import { useNavigate, useParams } from "react-router-dom";


export default () => {
  
  const moduleName = `contents`;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [state, setState] = useState(``);
  const [name, setName] = useState(``);
  const [description, setDescription] = useState(``);

  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);


  const onChange = (value) => setCategoryId(value);
  const handleChangeState = (value) => setState(value);
  const handleDescriptionChange = (value) => setDescription(value);


  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.contents_store != undefined && appReducer.contents_store.error == false) ||
        (appReducer.contents_update != undefined && appReducer.contents_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.contents_store,
    appReducer.contents_update
  ])

  useEffect(() => {
    if (appReducer.tags_option_list != undefined) {
      setCategories(appReducer.tags_option_list.data);
    }
  }, [appReducer.tags_option_list]);


  useEffect(() => {
    if (appReducer.contents_edit != undefined && id != undefined) {
      let row = appReducer.contents_edit.data;
      setName(row.name);
      if(row.tag){
        setCategoryId({
          value: row.tag.id,
          label: row.tag.name,
        });
      }
     
      setDescription(row.description);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.contents_edit]);

  useEffect(() => {
    dispatch(actions.list(`tags/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.SingleSelect
      withLabel
      required
      placeholder="انتخاب دسته‌بندی"
      name="tag_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <div>
      <EditorField
        label="توضیحات"
        onEditorChange={handleDescriptionChange}
        value={description}
      />
      <input name="description" type="hidden" defaultValue={description} />
    </div>
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};